import request from '@/utils/request'

const url = '/home/brand/'
const api = {
  getFamousBrands (data) {
    return request({
      url: url + 'getFamousBrands',
      method: 'post',
      data
    })
  },
  getLetterBrandsList (data) {
    return request({
      url: url + 'getLetterBrandsList',
      method: 'post',
      data
    })
  },
  getBrand (data) {
    return request({
      url: url + 'getBrand',
      method: 'post',
      data
    })
  },
  brandCategpry (data) {
    return request({
      url: url + 'brandCategpry',
      method: 'post',
      data
    })
  },
  getGroupList (data) {
    return request({
      url: url + 'getGroupList',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/brand.js